import React from 'react'
import { ScrollView } from 'react-native'

import { colors, H6, IconButton, SH2, Stack, XStack } from '@zet/design-system'
import { useBackHandler } from '@zet/design-system/hooks'

const ExperianTermsOfUse = ({ navigation }) => {
  useBackHandler(() => {
    navigation.goBack()
    return true
  })

  return (
    <Stack className="flex-1 bg-white">
      <XStack className="border-grays-40 items-center border-b bg-white p-3">
        <IconButton
          type={'Close'}
          color={colors.grays[80]}
          onPress={navigation.goBack}
        />
        <H6 className="ml-2 overflow-hidden text-ellipsis whitespace-nowrap">
          Experian - Consumer consent
        </H6>
      </XStack>
      <ScrollView contentContainerStyle={{ padding: 20 }}>
        <SH2 style={{ textAlign: 'justify' }}>
          {`
CONSENT STATEMENT:
You hereby consent to CLIENT being appointed as your authorized representative to receive your Credit Information
from Experian for the purpose of purpose of recommending better financial products to Individual Consumer (“End
Use Purpose”), on ongoing basis for not exceeding a period of six (6) months. I also agree to Experian T&C.
TERMS AND CONDITIONS:
This End User Agreement (the “Agreement”) is made between you (the “User” or “You”) and Vistas Technolabs Private
Limited, a private limited company having its registered office at 1105, Rawal Ji Ka Bazar, Near Hotel Sun City, Ganga
Pol, Jaipur 302002 (“CLIENT”, “Us” or “We”, which term shall include its successors and permitted assigns). The User
and CLIENT shall be collectively referred to as the “Parties” and individually as a “Party”.
BY EXECUTING THIS AGREEMENT / CONSENT FORM, YOU ARE EXPRESSLY AGREEING TO ACCESS THE EXPERIAN
CREDIT INFORMATION REPORT AND CREDIT SCORE, AGGREGATE SCORES, INFERENCES, REFERENCES AND DETAILS
(AS DEFINED BELOW) (TOGETHER REFERRED AS “CREDIT INFORMATION”). YOU HEREBY ALSO CONSENT TO SUCH
CREDIT INFORMATION BEING PROVIDED BY EXPERIAN TO YOU AND CLIENT BY USING EXPERIAN TOOLS,
ALGORITHMS AND DEVICES AND YOU HEREBY AGREE, ACKNOWLEDGE AND ACCEPT THE TERMS AND CONDITIONS
SET FORTH HEREIN.
Information Collection, Use, Confidentiality, No-Disclosure and Data Purging
CLIENT shall access your Credit Information as your authorized representative and CLIENT shall use the Credit
Information for limited End Use Purpose consisting of and in relation to the services proposed to be availed by you
from CLIENT. We shall not aggregate, retain, store, copy, reproduce, republish, upload, post, transmit, sell or rent the
Credit Information to any other person and the same cannot be copied or reproduced other than as agreed herein and
in furtherance to CICRA.
The Parties agree to protect and keep confidential the Credit Information both online and offline.
The Credit Information shared by you or received on by us on your behalf shall be destroyed, purged, erased promptly
of upon the completion of the transaction/ End Use Purpose for which the Credit Information report was procured for
up to a maximum of 6 months.
Governing Law and Jurisdiction
The relationship between you and CLIENT shall be governed by laws of India and all claims or disputes arising there
from shall be subject to the exclusive jurisdiction of the courts of Mumbai.
Definitions:
Capitalized terms used herein but not defined above shall have the following meanings:
“Business Day” means a day (other than a public holiday) on which banks are open for general business in Mumbai.
“Credit Information Report” means the credit information / scores/ aggregates / variables / inferences or reports
which shall be generated by Experian;
“Credit Score” means the score which shall be mentioned on the Credit Information Report which shall be computed
by Experian.
“CICRA” shall mean the Credit Information Companies (Regulation) Act, 2005 read with the Credit Information
Companies Rules, 2006 and the Credit Information Companies Regulations, 2006, and shall include any other rules and
regulations prescribed thereunder.
** This document is an electronic record in terms of the Information Technology Act, 2000 and Rules made there
under, and the amended provisions pertaining to electronic records.
`}
        </SH2>
      </ScrollView>
    </Stack>
  )
}

export default ExperianTermsOfUse
